import axios from 'axios';

// Cambiar la URL base para prevenir conexiones durante desarrollo
const API_URL = process.env.NODE_ENV === 'development' 
  ? '/mock-api' // URL base que no intentará conectarse a un servidor real
  : process.env.REACT_APP_API_URL || 'http://localhost:8000/api';

// Crear instancia de axios con configuración base
const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Interceptor para agregar token a las peticiones
api.interceptors.request.use(
  config => {
    // Si estamos en desarrollo, no enviar las peticiones reales
    if (process.env.NODE_ENV === 'development' && config.baseURL === '/mock-api') {
      // Cancelar la petición real para evitar errores en consola
      return Promise.reject(new Error('DEVELOPMENT_MODE_CANCEL'));
    }
    
    const token = localStorage.getItem('token');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// Interceptor para manejar errores de respuesta
api.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    // Ignorar errores específicos de desarrollo
    if (error.message === 'DEVELOPMENT_MODE_CANCEL') {
      // Devolver una respuesta simulada para evitar errores
      return Promise.resolve({ data: [] });
    }
    
    // Si hay error 401 (no autorizado), redirigir al login
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;